import { render, staticRenderFns } from "./ListPax.vue?vue&type=template&id=72e0098d&"
import script from "./ListPax.vue?vue&type=script&lang=js&"
export * from "./ListPax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports